export const PASSWORD_VALIDATION = {
  MIN_LENGTH: 'Minimum 8 characters required.',
  MAX_LENGTH: 'Maximum 20 characters are allowed.',
  FORMAT:
    'Ensure your password is between 8 and 20 characters long, incorporating a mix of lowercase letters (a-z), uppercase letters (A-Z), numbers (0-9), and special characters (e.g., !#$%&()*+,-./:;<=>?@[]^`{|}~) for enhanced security.',
  NO_SPACES: 'Password contains invalid spaces. Please remove any spaces and try again!',
  REQUIRED: 'Please enter password.',
};

export const FIRST_NAME_LENGTHS = {
  MIN: 2,
  MAX: 50,
};

export const LAST_NAME_LENGTHS = {
  MIN: 2,
  MAX: 50,
};

export const FIRST_NAME_VALIDATION = {
  REQUIRED: 'Please enter your First Name.',
  MAX_LENGTH: `Value should be less than ${FIRST_NAME_LENGTHS.MAX} character`,
  MIN_LENGTH: `Must be at least ${FIRST_NAME_LENGTHS.MIN} characters`,
  MIN_MAX_LENGTH: `First Name must be at least ${FIRST_NAME_LENGTHS.MIN} characters and less than ${FIRST_NAME_LENGTHS.MAX} characters`,
  FORMAT: 'First Name does not allow numbers or special characters.',
};

export const LAST_NAME_VALIDATION = {
  REQUIRED: 'Please enter your Last Name.',
  MAX_LENGTH: `Value should be less than ${LAST_NAME_LENGTHS.MAX} character`,
  MIN_LENGTH: `Must be at least ${LAST_NAME_LENGTHS.MIN} characters`,
  MIN_MAX_LENGTH: `Last Name must be at least ${LAST_NAME_LENGTHS.MIN} characters and less than ${LAST_NAME_LENGTHS.MAX} characters`,
  FORMAT: 'Last Name does not allow numbers or special characters.',
};
